import { isMobile, isAndroid, isElectron } from '../env/os/index';
import { isKsAPP } from '../env/kuaishou/index';
import { isMiniprogram } from '../env/wechat/index';
// 参考https://docs.corp.kuaishou.com/d/home/fcACB6VLyXmqRChQheBSHqGsK
export var Platform;
(function (Platform) {
    Platform["WINDOWS_PC"] = "WINDOWS_PC";
    Platform["ANDROID_PHONE_H5"] = "ANDROID_PHONE_H5";
    Platform["IPHONE_H5"] = "IPHONE_H5";
    Platform["OUTSIDE_ANDROID_H5"] = "OUTSIDE_ANDROID_H5";
    Platform["OUTSIDE_IOS_H5"] = "OUTSIDE_IOS_H5";
    Platform["PC_WEB"] = "PC_WEB";
    Platform["WX_MINI_PROGRAM"] = "WX_MINI_PROGRAM";
})(Platform || (Platform = {}));
// kpf 函数库提供统一获取方法，业务方可自行调用传入，不传的话，网络库内会引入函数库获取方法兜底。
// 2、kpf为动态检测当前环境，传递值为字符串，如ANDROID_PHONE_H5或PC_WEB
export var getKpf = function () {
    if (isMobile) {
        // 端内H5
        if (isKsAPP) {
            return isAndroid ? Platform.ANDROID_PHONE_H5 : Platform.IPHONE_H5;
        }
        // 判断是否在小程序里
        if (isMiniprogram) {
            return Platform.WX_MINI_PROGRAM;
        }
        // 端外H5
        return isAndroid ? Platform.OUTSIDE_ANDROID_H5 : Platform.OUTSIDE_IOS_H5;
    }
    // pc情况
    if (isElectron) {
        return Platform.WINDOWS_PC;
    }
    return Platform.PC_WEB;
};
export var kpf = getKpf();
